import { Utils } from 'Shared/utils';
import { Auth } from 'Shared/auth';
import { Navigation as CleanNavigation } from './clean_navigation';

function logIn() {
   Auth.login({
      reload: !Utils.hasUnsavedChanges(),
   });
}

const Navigation = props => {
   const isLoggedIn = Auth.isLoggedIn();
   return <CleanNavigation {...props} logIn={logIn} isLoggedIn={isLoggedIn} />;
};

export default Navigation;
